import { IHomeSectionResponse } from '../../../../model/apm/home/response/home-section-response';
import { IHomeSectionItemResponse } from '../../../../model/apm/home/response/home-section-item-response';
import { IBannerResponse } from '../../../../model/apm/banner/response/banner-response';
import { TipoBanner } from '../../../../model/apm/apm-enums';

// Banner fora do período de exibição não aparece no portal
export function isItemActive(item: IHomeSectionItemResponse, today: string): boolean {
    if (!item.isVisible) return false;
    const start = item.startDate?.substring(0, 10);
    const end = item.endDate?.substring(0, 10);
    if (start && today < start) return false;
    if (end && today > end) return false;
    return true;
}

// Carrossel do topo (tela de Banners): fora da customização, sempre entre o header e as seções
export function topCarouselBanners(banners: IBannerResponse[], today: string): IBannerResponse[] {
    return banners
        .filter((b) => b.isPublished && b.type !== TipoBanner.Popup && !!b.image)
        .filter((b) => b.isPermanent || (
            (!b.startDate || today >= b.startDate.substring(0, 10)) && (!b.endDate || today <= b.endDate.substring(0, 10))
        ))
        .sort((a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER));
}

export function visibleSections(sections: IHomeSectionResponse[], today: string): IHomeSectionResponse[] {
    return sections
        .filter((s) => s.isVisible)
        .map((s) => ({ ...s, items: (s.items || []).filter((i) => isItemActive(i, today)) }));
}
